import {
  MotifButton,
  MotifButtonGroup,
  MotifDropdown,
  MotifDropdownItem,
  MotifDropdownPortal,
  MotifFormField,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirMoreVert, IconoirNavArrowDown } from "@ey-xd/motif-icon";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  useExportAdvanceSearchMutation,
  useLazyExportDocumentQuery,
} from "@/services/exports/exportsReducer";
import SearchInput from "@/components/SearchInput/SearchInput";
import { useDispatch, useSelector } from "react-redux";
import {
  resetCreditorSetup,
  updateStage,
} from "@/pages/CaseDetail/Creditor/CreditorSetup/creditorSetupSlice";
import { commonFormateName, havingAddPermission } from "@/utility/common";
import {
  CREATE_BUTTON_VARIANT,
  CLOSE_BUTTON_VARIANT,
  getCommonCloseImg,
} from "@/components/Images/CommonImages";
import { setCreditorAttributes } from "@/pages/CaseDetail/Creditor/CreditorSetup/CreditorAttributesSlice";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
interface TitleComplementProps {
  caseId: string | undefined;
  setShowBasicSearch: any;
  showBasicSearch: any;
  clearBasicSearch: any;
  clearSearch: any;
  setClearSearch: any;
  onSearch: (searchValue: string) => void;
  handleQuickSearchClear: () => void;
  searchQuery: string;
  setShowAdvanceSearch: (isVisible: boolean) => void;
  showAdvanceSearch: boolean;
  basicSearchPayload: any;
  isBasicSearchActive: boolean;
  advanceSearchPayload: any;
  isAdvanceSearch: boolean;
  handleEditSearch: () => void;
  resetSortStatus?: any;
  Creditor?: string[];
  ImportJob?: string[];
  setErrorMessage?: any;
  setShowBulkUploadModal: any;
}

export default function TitleComplement({
  setShowBasicSearch,
  showBasicSearch,
  clearBasicSearch,
  clearSearch,
  setClearSearch,
  onSearch,
  caseId,
  handleQuickSearchClear,
  searchQuery,
  showAdvanceSearch,
  setShowAdvanceSearch,
  basicSearchPayload,
  isBasicSearchActive,
  advanceSearchPayload,
  isAdvanceSearch,
  handleEditSearch,
  resetSortStatus,
  Creditor,
  ImportJob,
  setErrorMessage,
  setShowBulkUploadModal,
}: TitleComplementProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [exportDocument, { isLoading: exportLoading }] =
    useLazyExportDocumentQuery();
  const [exportAdvanceSearch, { isLoading: advancedSearchExportLoading }] =
    useExportAdvanceSearchMutation();
  const [showMenu, setShowMenu] = useState(false);
  const [searchValue, setSearchValue] = useState(searchQuery);
  const searchDropMenu = [
    "pages.creditors.searchOptions.basicSearch",
    "pages.creditors.searchOptions.advancedSearch",
  ];
  const { caseShortName, abbreviation } = useSelector(
    (state: any) => state.case
  );

  const debtorTitleMenu = [
    { lable: "pages.creditors.moreOptions.export", value: "export" },
  ]; // "pages.creditors.moreOptions.bulkStatusUpdate", Removed bulk status update button temporarily
  if (
    ImportJob &&
    havingAddPermission(ImportJob) &&
    havingAddPermission(Creditor || [])
  ) {
    debtorTitleMenu.push({
      lable: "pages.creditors.moreOptions.bulkUpload",
      value: "bulkUpload",
    });
  }

  const navigate = useNavigate();
  const handleSearchChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setSearchValue(event.target.value);
  };

  function handleOnSearch() {
    onSearch(searchValue);
  }

  function basicSearch(getIndex: number) {
    if (getIndex === 0) {
      setShowBasicSearch(true);
      setShowAdvanceSearch(false);
    } else {
      setShowBasicSearch(false);
      setShowAdvanceSearch(true);
    }
  }

  const handleMenuClick = (value: string) => {
    setErrorMessage("");
    if (value === "export") {
      if (isAdvanceSearch && !searchQuery) {
        exportAdvanceSearch({
          url: "/CreditorAdvancedSearch/ExportCreditorsAdvancedSearch",
          data: advanceSearchPayload,
          fileName: caseShortName
            ? commonFormateName(caseShortName, "Creditor", abbreviation)
            : "",
        })
          .then((response) => {
            if ("error" in response && "data" in response.error) {
              try {
                const errObj = JSON.parse(response?.error?.data as string);
                setErrorMessage(errObj?.message || errObj.title);
              } catch (error) {
                setErrorMessage("Something went wrong!!");
              }
            }
          })
          .catch((error: any) => {
            setErrorMessage("Something went wrong!!");
          });
        return;
      }
      const createBasicSearchPayload = {
        CreditorName: basicSearchPayload?.creditorName,

        CreditorReference: basicSearchPayload?.creditorId,

        ClaimReference: basicSearchPayload?.claimId,

        DebtorName: basicSearchPayload?.debtorName,

        CountryId: basicSearchPayload?.country,

        ProvinceStateId: basicSearchPayload?.province,

        PostalCode: basicSearchPayload?.postalCode,

        PhoneNumber: basicSearchPayload?.phoneNumber,

        ClaimUpdateDate: basicSearchPayload?.updateDate,

        PageNumber: basicSearchPayload?.PageNumber,

        PageSize: basicSearchPayload?.PageSize,

        SortColumn: basicSearchPayload?.SortColumn,

        SortOrder: basicSearchPayload?.SortOrder,

        CaseId: basicSearchPayload?.caseId,
      };
      exportDocument(
        isBasicSearchActive && !searchQuery
          ? {
              url: "/Creditor/ExportCreditors",
              ...createBasicSearchPayload,
              fileName: caseShortName
                ? commonFormateName(caseShortName, "Creditor", abbreviation)
                : "",
            }
          : {
              url: "/Creditor/ExportCreditorslistAndQuickSearch",
              caseId,
              SearchText: searchQuery,
              fileName: caseShortName
                ? commonFormateName(caseShortName, "Creditor", abbreviation)
                : "",
            }
      )
        .then((response) => {
          if (response?.error && "data" in response.error) {
            try {
              const errObj = JSON.parse(response?.error?.data as string);
              setErrorMessage(errObj?.message || errObj.title);
            } catch (error) {
              setErrorMessage("Something went wrong!!");
            }
          }
        })
        .catch((error: any) => {
          setErrorMessage("Something went wrong!!");
        });
      return;
    }
    if (value === "bulkUpload") {
      setShowBulkUploadModal(true);
      return;
    }
  };

  return (
    <>
      <div
        className={
          showBasicSearch ? "show-and-hide-quicksearch" : "show-quick-search"
        }
      >
        <MotifFormField>
          <div
            style={
              !showBasicSearch || !showAdvanceSearch
                ? { visibility: "visible", width: "180px" }
                : { visibility: "hidden" }
            }
            className="creditor-search-input-div"
          >
            {!showBasicSearch && !showAdvanceSearch ? (
              <SearchInput
                aria-label="Search"
                onChange={handleSearchChange}
                placeholder={t(
                  "global.globalPlaceholder.quickSearchPlaceHolder"
                )}
                onFocusShow={false}
                value={searchQuery}
                withOutDebounce={true}
                onEnter={handleOnSearch}
                onClear={() => {
                  handleQuickSearchClear();
                }}
              />
            ) : (
              ""
            )}
          </div>
          <MotifButtonGroup className="search-button-group">
            <MotifButton variant="secondary" onClick={handleOnSearch}>
              {t("global.globalPlaceholder.searchTypesDropdown")}
            </MotifButton>
            <MotifDropdownPortal
              open={showMenu}
              hideArrow={true}
              handleClickOutside={() => setShowMenu(false)}
              trigger={
                <MotifButton
                  type="button"
                  onClick={() => setShowMenu(!showMenu)}
                  aria-label="Dropdown button"
                  aria-haspopup="true"
                  variant="secondary"
                >
                  <MotifIcon
                    aria-label="Dropdown icon"
                    fill="none"
                    iconFunction={IconoirNavArrowDown}
                  />
                </MotifButton>
              }
            >
              {searchDropMenu.map((dropMenu: string, index: number) => {
                return (
                  <MotifDropdownItem onClick={() => basicSearch(index)}>
                    {t(dropMenu)}
                  </MotifDropdownItem>
                );
              })}
            </MotifDropdownPortal>
          </MotifButtonGroup>
          {clearSearch ? (
            <div className="search-div">
              <MotifButton
                size="small"
                variant={CLOSE_BUTTON_VARIANT}
                onClick={() => {
                  clearBasicSearch();
                  setClearSearch(false);
                  dispatch(
                    setComponentState1({
                      entityName: "creditorListTabState",
                      entityState: { clearSearch: false },
                    })
                  );
                }}
                type="button"
                title="Clear Search"
              >
                {getCommonCloseImg()}
              </MotifButton>
              <MotifButton
                style={{ marginTop: "-46px", marginLeft: "57px" }}
                size="small"
                type="button"
                variant={CREATE_BUTTON_VARIANT}
                onClick={handleEditSearch}
              >
                {t("pages.creditors.editSearch")}
              </MotifButton>
            </div>
          ) : (
            ""
          )}
          <div>
            {Creditor && havingAddPermission(Creditor) && (
              <MotifButton
                className="create-creditor-button"
                style={{ marginTop: "1px", marginLeft: "20px", height: "44px" }}
                variant={CREATE_BUTTON_VARIANT}
                onClick={() => {
                  navigate(`/case/${caseId}/creditor/creditor-setup`);
                  dispatch(resetCreditorSetup());
                  dispatch(setCreditorAttributes([]));
                  dispatch(updateStage(0));
                }}
              >
                {t("pages.creditors.createCreditor")}
              </MotifButton>
            )}
          </div>
          <div style={{ width: "2rem" }}>
            <MotifDropdown
              ariaLabelledby="dropdown-trigger-1"
              id="dropdown-1"
              placement="bottom"
              trigger={
                <MotifButton
                  aria-label="Search Dropdown"
                  id="dropdown-trigger-1"
                  onClick={function Ga() {}}
                  type="button"
                  variant="text"
                  loading={advancedSearchExportLoading || exportLoading}
                >
                  <MotifIcon iconFunction={IconoirMoreVert} />
                </MotifButton>
              }
            >
              <ul role="menu">
                {debtorTitleMenu.map((menuName) => {
                  return (
                    <li role="menuitem">
                      <MotifDropdownItem
                        indexItem={1}
                        onClick={() => handleMenuClick(menuName.value)}
                      >
                        {t(menuName.lable)}
                      </MotifDropdownItem>
                    </li>
                  );
                })}
              </ul>
            </MotifDropdown>
          </div>
        </MotifFormField>
      </div>
    </>
  );
}
